import React, { useRef, useLayoutEffect } from "react";

import Input from "../input/input";
import Button from "../button/button";
import { useFormInput } from "../../custom-hooks/useFormInput";
import { useRequiredValidation } from "../../custom-hooks/useRequiredValidation";
import { saveWidget, addBookmark } from "../../actions/layoutActions";
import { hideModal } from "../../actions/modalActions";
import "./bookmark.scss";
import {
  eventCategories,
  recordEvent
} from "../../utils/googleAnalyticsEvents";
import { useAppSelector, useAppDispatch } from "../../hooks";
import type { ButtonActivationEvent } from "../button/button";

export interface EditBookmarkProps {
  widget_id: string;
}

export default function EditBookmark(props: EditBookmarkProps) {
  const dispatch = useAppDispatch();
  const bookmarks = useAppSelector(state => state.layouts.bookmarks);

  const bookmark = bookmarks
    ? bookmarks.find(bookmark => bookmark.widget_id === props.widget_id)
    : null;
  const bookmarkUrl = useFormInput(bookmark?.url);
  const bookmarkName = useFormInput(bookmark?.name);
  const bookmarkUrlRequired = useRequiredValidation(true, bookmarkUrl.value);
  const bookmarkNameRequired = useRequiredValidation(true, bookmarkName.value);
  const urlRef = useRef<HTMLInputElement | null>(null);

  useLayoutEffect(() => {
    urlRef.current?.focus();
  }, [urlRef]);

  const onSubmit = (event: ButtonActivationEvent) => {
    event.preventDefault();
    bookmarkUrlRequired.onInvalid();
    bookmarkNameRequired.onInvalid();
    if (
      bookmarkUrlRequired.isFieldFilled &&
      bookmarkNameRequired.isFieldFilled
    ) {
      recordEvent(
        "Bookmark Config Saved",
        eventCategories.COMPONENT_CONFIGURATION,
        "Bookmark Config Saved"
      );
      dispatch(saveWidget(props.widget_id));
      dispatch(
        addBookmark({
          widget_id: props.widget_id,
          url: bookmarkUrl.value,
          name: bookmarkName.value
        })
      );
      dispatch(hideModal());
    }
  };

  return (
    <div>
      <Input
        label="URL"
        placeholder="URL"
        id="url"
        type="text"
        name="url"
        {...bookmarkUrl}
        required={true}
        ariaLabel="URL"
        validations={bookmarkUrlRequired.validations}
        reference={urlRef}
        usePermanentAccent
      />
      <Input
        label="Friendly Name"
        placeholder="Friendly Name"
        id="name"
        type="text"
        name="name"
        {...bookmarkName}
        required={true}
        ariaLabel="Friendly Name"
        validations={bookmarkNameRequired.validations}
        usePermanentAccent
      />
      <Button type="submit" onClick={onSubmit} usePermanentAccent>
        Save Bookmark
      </Button>
    </div>
  );
}
